<script setup lang="ts">
import useAuthStore from '@/stores/auth'
import useFetchStore from '@/stores/fetch'
import { watch } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const fetchStore = useFetchStore()
const authStore = useAuthStore()

watch(
  () => fetchStore.error,
  (newError) => {
    if (newError) {
      switch (newError.code) {
        case 401:
          authStore.logout()
          break
        case 403:
          router.push({ name: 'error403' })
          break
        case 500:
          router.push({ name: 'something-went-wrong' })
          break
        default:
          break
      }

      fetchStore.error = undefined
    }
  }
)
</script>

<template>
  <div class="hidden"></div>
</template>
